import { FilterInterface, Filters } from "modules/spravochnik/dt-front-page-generator/src/Entity/Filter";

export class PageItemsFilter {
    private _filters: Array<{ identity: string, value: any }>;

    constructor(filters: Filters|null = null) {
        if (filters) {
            this.setFilters(filters)
        }
    }

    private setFilters(filters: Filters) {
        const list = [];
        for (const filter of filters) {
            const value = filter.value.toServerParam();
            if (value !== null) {
                list.push({identity: filter.id, value: value});
            }
        }
        this._filters = list;
    }

    get filters(): Array<{ identity: string; value: any }> {
        return this._filters.filter((filter: { identity: string, value: any }) => filter.value !== undefined);
    }
}
